import { compact } from "lodash";
import React, { useState } from "react";
import { Image as ImageType } from "../../types";
import { Price } from "../pricing";
import ProductCard from "../product-card";
import RelatedProductModal from "./related-product-modal";
import { useI18next } from "gatsby-plugin-react-i18next";

interface RelatedProductCardProps {
  productName: string;
  rating?: number;
  destinationName?: string;
  headerImage?: ImageType;
  images?: ImageType[];
  description?: string;
  summary?: string;
  price?: Price;
  isExcursion?: boolean;
}

const RelatedProductCard: React.FC<RelatedProductCardProps> = ({
  productName,
  rating,
  destinationName,
  headerImage,
  images,
  description,
  summary,
  price,
  isExcursion,
}) => {
  const [hasModalVisible, setModalVisible] = useState<boolean>(false);
  const { t } = useI18next();

  const handleOpenModalClick = () => {
    setModalVisible(true);

    if (typeof document !== "undefined") {
      document.body.classList.toggle("has-overlay", true);
      const pageElement = document.querySelector(".page");
      if (pageElement) {
        pageElement.classList.toggle("page-blurred", true);
      }
    }
  };

  const handleCloseModalClick = () => {
    setModalVisible(false);

    if (typeof document !== "undefined") {
      document.body.classList.toggle("has-overlay", false);
      const pageElement = document.querySelector(".page");
      if (pageElement) {
        pageElement.classList.toggle("page-blurred", false);
      }
    }
  };

  return (
    <ProductCard
      cardType="modal"
      title={productName}
      linkText={t("SHOW_DETAILS")}
      rating={rating}
      imageSrc={headerImage?.url ?? undefined}
      imageAlt={headerImage?.altText ?? undefined}
      locationNames={compact([destinationName])}
      onClick={handleOpenModalClick}
      description={description}
      price={price}
      showAllIcons={true}
      isExcursion={isExcursion}
    >
      <RelatedProductModal
        active={hasModalVisible}
        headerImage={headerImage}
        images={images}
        destinationName={destinationName}
        productName={productName}
        rating={rating}
        description={description}
        summary={summary}
        price={price}
        onCloseClick={handleCloseModalClick}
      />
    </ProductCard>
  );
};

export default RelatedProductCard;
